const IS_LOADING = "list/product_identification_number_type/IS_LOADING";
const IS_ERROR = "list/product_identification_number_type/IS_ERROR";
const LIST = "list/product_identification_number_type/LIST";
const EDIT = "list/product_identification_number_type/EDIT";

export { IS_LOADING, IS_ERROR, LIST, EDIT };
